import { Bell } from 'lucide-react';

import { NodeShell } from './NodeShell';

interface NotificationNodeData {
  label: string;
  title?: string;
  to?: string;
}

export const NotificationNode = ({
  data,
  selected,
}: {
  data: NotificationNodeData;
  selected?: boolean;
}) => (
  <NodeShell
    type="notification"
    icon={<Bell size={16} />}
    label={data.label}
    subtitle={data.to ? `To: ${data.to}` : 'All extension users'}
    selected={selected}
    sources={[
      {
        id: 'sent',
        top: '32%',
        handleClass: '!bg-green-500',
        label: 'sent',
        labelClass: 'text-green-600',
      },
      {
        id: 'failed',
        top: '68%',
        handleClass: '!bg-red-500',
        label: 'failed',
        labelClass: 'text-red-600',
      },
    ]}
  />
);
